@if (isVerticalNavigationEnabled()) {
  <div class="row align-items-center justify-content-between">
    <h2 class="col mb-0">
      {{ 'scan_results_for_scan' | translate: [scanTitle] }}
    </h2>
    <div class="col-auto d-flex align-items-center gap-3">
      <app-export-report-button
        (onDownloadReport)="onDownloadReport($event)"
        [fileExtensions]="fileExtensions$ | async"
        [shareModalInputData]="modalInputData"
        [canDownloadReport]="canDownloadReport$ | async"
      >
      </app-export-report-button>
      @if (!isMonitoringTag && !$isMobileDigitalProperty()) {
        <app-testing-tool-filter
          [currentSelection]="auditTool"
          [toolsToExclude]="toolsToExclude"
          (onToolSelected)="onToolSelect($event)"
        >
        </app-testing-tool-filter>
      }
    </div>
  </div>
  @if (findingsDetailsRefreshEnabled()) {
    <div class="d-flex flex-wrap gap-2 mt-2" data-test-id="scan-metadata">
      <ds-chip [colorVariant]="DsChipColorVariant.Primary" [text]="scanTag" data-test-id="scan-tag"></ds-chip>
      @if (scanOriginLabel) {
        <ds-chip [colorVariant]="scanOriginChipVariant" [text]="scanOriginLabel" data-test-id="scan-origin"></ds-chip>
      }
      <ds-chip [colorVariant]="DsChipColorVariant.Light" [text]="formattedScanDate" data-test-id="scan-date"></ds-chip>
      <app-viewport-inline
        [scanViewport]="scanViewPort"
        [hideViewportLabel]="isMobileXmlScan"
        [useChip]="true"
      ></app-viewport-inline>
      @if (standardAndConformanceLevel) {
        <ds-chip
          [colorVariant]="DsChipColorVariant.Light"
          [text]="standardAndConformanceLevel | translate"
          data-test-id="conformance-level"
        ></ds-chip>
      }
      <ds-chip
        data-test-id="pages-scanned"
        [colorVariant]="DsChipColorVariant.Light"
        [text]="
          ($isMobileDigitalProperty() ? 'scan_results_screens_scanned' : 'scan_results_pages_scanned')
            | translate: [totalScannedPages, totalCrawledPages]
        "
      ></ds-chip>
      @if (formattedScanTool) {
        <ds-chip [colorVariant]="DsChipColorVariant.Light" [text]="formattedScanTool" data-test-id="scan-tool"></ds-chip>
      }
    </div>
  } @else {
    <div class="row my-4">
      <div>
        <ds-chip [colorVariant]="DsChipColorVariant.Primary" [text]="scanTag"></ds-chip>
        <span class="px-2" data-test-id="scan-date">{{ formattedScanDate }}</span> |
        <app-viewport-inline
          class="px-1"
          [scanViewport]="scanViewPort"
          [hideViewportLabel]="isMobileXmlScan"
        ></app-viewport-inline>
        |
        <span class="px-2" data-test-id="conformance-level">{{ standardAndConformanceLevel | translate }}</span> |
        <span class="px-2" data-test-id="pages-scanned">{{
          ($isMobileDigitalProperty() ? 'scan_results_screens_scanned' : 'scan_results_pages_scanned')
            | translate: [totalScannedPages, totalCrawledPages]
        }}</span>
        @if (currToolVersion) {
          <span>
            |
            <span class="px-2" data-test-id="scan-tool">
              {{ formattedScanTool }}
            </span>
          </span>
        }
      </div>
    </div>
  }
} @else {
  <div class="card">
    <div class="card-header">
      <div class="row justify-content-between">
        <h2 class="col-lg-8">
          {{ 'scan_results_for_scan' | translate: [scanTitle] }}
        </h2>
        @if (!isMonitoringTag && !$isMobileDigitalProperty()) {
          <app-testing-tool-filter
            class="col-lg-4 d-flex justify-content-end"
            [currentSelection]="auditTool"
            [toolsToExclude]="toolsToExclude"
            (onToolSelected)="onToolSelect($event)"
          >
          </app-testing-tool-filter>
        }
      </div>
    </div>
    <div class="card-body">
      <div class="row align-items-start">
        <div class="col-lg-8">
          <small class="scan-tag-alt-badge">{{ scanTag }}</small>
          <span class="px-2" data-test-id="scan-date">{{ formattedScanDate }}</span> |
          <app-viewport-inline
            class="px-1"
            [scanViewport]="scanViewPort"
            [hideViewportLabel]="isMobileXmlScan"
          ></app-viewport-inline>
          |
          <span class="px-2" data-test-id="conformance-level">{{ standardAndConformanceLevel | translate }}</span> |
          <span class="px-2" data-test-id="pages-scanned">{{
            ($isMobileDigitalProperty() ? 'scan_results_screens_scanned' : 'scan_results_pages_scanned')
              | translate: [totalScannedPages, totalCrawledPages]
          }}</span>
          @if (currToolVersion) {
            <span>
              |
              <span class="px-2" data-test-id="scan-tool">
                {{ formattedScanTool }}
              </span>
            </span>
          }
        </div>
        <div class="col-12 col-lg-4 d-flex share-btn-wrapper">
          <app-export-report-button
            (onDownloadReport)="onDownloadReport($event)"
            [fileExtensions]="fileExtensions$ | async"
            [shareModalInputData]="modalInputData"
            [canDownloadReport]="canDownloadReport$ | async"
          >
          </app-export-report-button>
        </div>
      </div>
    </div>
  </div>
}
